import { useState } from "react";
import { ExportMenuItem } from "@design-system/ExportMenuItem/ExportMenuItem";
import { OpenMenuCell } from "./MenuPlaygroundCell";
import { VariantGrid } from "./playgroundControls";

/** Click a row: it shows its spinner for a moment and the menu stays open. */
const ExportRows = () => {
    const [downloadingFormat, setDownloadingFormat] = useState<string>();
    const startDownload = (format: string) => {
        setDownloadingFormat(format);
        setTimeout(() => setDownloadingFormat(undefined), 1500);
    };

    return (
        <>
            <ExportMenuItem
                isDownloading={downloadingFormat === "csv"}
                onClick={() => startDownload("csv")}
            >
                Export transactions (.csv)
            </ExportMenuItem>
            <ExportMenuItem
                isDownloading={downloadingFormat === "xlsx"}
                onClick={() => startDownload("xlsx")}
            >
                Export transactions (.xlsx)
            </ExportMenuItem>
        </>
    );
};

/** The design-system rows built on `Menu`: download rows that stay open. */
export const MenuPlaygroundWrappers = () => (
    <VariantGrid title="Wrappers" columns="three">
        <OpenMenuCell label="ExportMenuItem · stays open while downloading">
            <ExportMenuItem isDownloading onClick={() => undefined}>
                Downloading (.csv)
            </ExportMenuItem>
            <ExportRows />
        </OpenMenuCell>
    </VariantGrid>
);
